import React, { useEffect, useState } from "react";

import Loading from "./Loading";
import { useLocation, Link } from "react-router-dom";

import { ProductsContext } from "../context/ProductsContext";
import bg_video from "../dist/img/output_movie.mov";

const Output = ({deleteStep , addStep , answer1_5}) => {
  //Context API

  const { p1, p1_old, p2, p3, p4, p4_old, p1_p2Visible } = React.useContext(ProductsContext);
  const [product1, setProduct1] = p1;
  const [product1_old, setProduct1_old] = p1_old;
  const [product2, setProduct2] = p2;
  const [product3, setProduct3] = p3;
  const [product4, setProduct4] = p4;
  const [product4_old, setProduct4_old] = p4_old;
  const [product1_2Visible, setProduct1_2Visible] = p1_p2Visible;
  //Use state
  const [loading, setLoading] = useState(true);

  const location = useLocation();
  if (location.state !== undefined) {
    const { backAnswer1_5 } = location.state;
    answer1_5 = backAnswer1_5;
  }

  if (answer1_5 === "option1") {
    var [product1_output, setProduct1_output] = p1;
    var [product4_output, setProduct4_output] = p4;
  }else if(answer1_5 === "option2"){
    var [product1_output, setProduct1_output] = p1_old;
    var [product4_output, setProduct4_output] = p4_old;
  }

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 4000);
  }, []);

  return loading ? (
    <Loading />
  ) : (
    <section className="c-question">
      <video poster="" autoPlay loop playsInline muted>
        <source src={bg_video} type="video/mp4"></source>
      </video>

      <section className="c-question__content p-treatment__content c-box3">
        <h1 className="c-question__title p-treatment__title">
          あなたの髪の記憶に最適なシステムトリートメント
        </h1>
        <table className="u-pc c-question__table">
          <tr>
            <th style={{ display: !product1_2Visible && "none" }}>ST1</th>
            <th style={{ display: !product1_2Visible && "none" }}>ST2</th>
            <th>ST3</th>
            <th>ST4</th>
          </tr>
          <tr>
            <td style={{ display: !product1_2Visible && "none" }}>
              <div>
                <img
                  src={require(`../dist/img/${product1_output.image}`).default}
                  alt={product1_output.title}
                />
              </div>
            </td>
            <td style={{ display: !product1_2Visible && "none" }}>
              <div>
                <img
                  src={require(`../dist/img/${product2.image}`).default}
                  alt={product2.title}
                />
              </div>
            </td>
            <td>
              <div>
                <img
                  style={{ width: product3.image === "ST3/ST3_H.png" && "37%" }}
                  src={require(`../dist/img/${product3.image}`).default}
                  alt={product3.title}
                />
              </div>
            </td>
            <td>
              <div>
                <img
                  src={require(`../dist/img/${product4_output.image}`).default}
                  alt={product4_output.title}
                />
              </div>
            </td>
          </tr>
          <tr>
            <td style={{ display: !product1_2Visible && "none"}}>
              ST{product1_output.title}1
              <span style={{whiteSpace:"pre-wrap", fontSize:"10px"}}>
                {answer1_5 === "option2" ? "\n※専用アプリケーターにうつしてお使いください" : ""}
              </span>
            </td>
            <td style={{ display: !product1_2Visible && "none" }}>
              {product2.title}
            </td>
            <td>{product3.title}</td>
            <td>ST{product4_output.title}4</td>
          </tr>
          <tr>
            <td style={{ display: !product1_2Visible && "none" }}>
              使用量 / 全頭
            </td>
            <td style={{ display: !product1_2Visible && "none" }}>
              使用量 / 全頭
            </td>
            <td>使用量 / 全頭</td>
            <td>使用量 / 全頭</td>
          </tr>
          <tr>
            <td style={{ display: !product1_2Visible && "none" }}>
              <ul>
                <li>ショート</li>
                <li>
                  {product1.id === "A" && answer1_5 === "option1" ? "9 〜 12g" : "6 〜 9g"}
                  <br />
                  {product1.id === "A" && answer1_5 === "option1" ? "3 〜 4プッシュ" : "2 〜 3プッシュ"}
                </li>
              </ul>
            </td>
            <td style={{ display: !product1_2Visible && "none" }}>
              <ul>
                <li>ショート</li>
                <li>10 〜 20プッシュ</li>
              </ul>
            </td>
            <td>
              <ul>
                <li>ショート</li>
                {product3.id === "I" ? (
                  <li>20 〜 40g</li>
                ) : (
                  <li>
                    6 〜 9g
                    <br />2 〜 3プッシュ
                  </li>
                )}
              </ul>
            </td>
            <td>
              <ul>
                <li>ショート</li>
                <li>
                  3 〜 6g
                  <br />1 〜 2プッシュ
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td style={{ display: !product1_2Visible && "none" }}>
              <ul>
                <li>ミディアム</li>
                <li>
                  {product1.id === "A" && answer1_5 === "option1" ? "15 〜 18g" : "12 〜 15g"}
                  <br />
                  {product1.id === "A" && answer1_5 === "option1" ? "5 〜 6プッシュ" : "4 〜 5プッシュ"}
                </li>
              </ul>
            </td>
            <td style={{ display: !product1_2Visible && "none" }}>
              <ul>
                <li>ミディアム</li>
                <li>20 〜 40プッシュ</li>
              </ul>
            </td>
            <td>
              <ul>
                <li>ミディアム</li>
                {product3.id === "I" ? (
                  <li>40 〜 60g</li>
                ) : (
                  <li>
                    12 〜 15g
                    <br />4 〜 5プッシュ
                  </li>
                )}
              </ul>
            </td>
            <td>
              <ul>
                <li>ミディアム</li>
                <li>
                  6 〜 9g
                  <br />2 〜 3プッシュ
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td style={{ display: !product1_2Visible && "none" }}>
              <ul>
                <li>ロング</li>
                <li>
                  {product1.id === "A" && answer1_5 === "option1" ? "21〜 24g" : "18 〜 21g"}
                  <br />
                  {product1.id === "A" && answer1_5 === "option1" ? "7 〜 8プッシュ" : "6 〜 7プッシュ"}
                </li>
              </ul>
            </td>
            <td style={{ display: !product1_2Visible && "none" }}>
              <ul>
                <li>ロング</li>
                <li>40 〜 60プッシュ</li>
              </ul>
            </td>
            <td>
              <ul>
                <li>ロング</li>
                {product3.id === "I" ? (
                  <li>60 〜 80g</li>
                ) : (
                  <li>
                    18 〜 21g
                    <br />6 〜 7プッシュ
                  </li>
                )}
              </ul>
            </td>
            <td>
              <ul>
                <li>ロング</li>
                <li>
                  9 〜 12g
                  <br />3 〜 4プッシュ
                </li>
              </ul>
            </td>
          </tr>
        </table>

        <table className="u-sp c-question__table">
          <tr style={{ display: !product1_2Visible && "none" }}>
            <th>ST1</th>
            <td>
              <div>
                <img
                  src={require(`../dist/img/${product1_output.image}`).default}
                  alt={product1_output.title}
                />
              </div>
            </td>
            <td>
              ST{product1_output.title}1
              <span style={{whiteSpace:"pre-wrap", fontSize:"10px"}}>
                {answer1_5 === "option2" ? "\n※専用アプリケーターにうつしてお使いください" : ""}
              </span>
            </td>
            <td>使用量 / 全頭</td>
            <td>
              <ul>
                <li>ショート</li>
                <li>
                  {product1.id === "A" && answer1_5 === "option1" ? "9 〜 12g" : "6 〜 9g"}
                  <br />
                  {product1.id === "A" && answer1_5 === "option1" ? "3 〜 4プッシュ" : "2 〜 3プッシュ"}
                </li>
              </ul>
            </td>
            <td>
              <ul>
                <li>ミディアム</li>
                <li>
                  {product1.id === "A" && answer1_5 === "option1" ? "15 〜 18g" : "12 〜 15g"}
                  <br />
                  {product1.id === "A" && answer1_5 === "option1" ? "5 〜 6プッシュ" : "4 〜 5プッシュ"}
                </li>
              </ul>
            </td>
            <td>
              <ul>
                <li>ロング</li>
                <li>
                  {product1.id === "A" && answer1_5 === "option1" ? "21 〜 24g" : "18 〜 21g"}
                  <br />
                  {product1.id === "A" && answer1_5 === "option1" ? "7 〜 8プッシュ" : "6 〜 7プッシュ"}
                </li>
              </ul>
            </td>
          </tr>
          <tr style={{ display: !product1_2Visible && "none" }}>
            <th>ST2</th>
            <td>
              <div>
                <img
                  src={require(`../dist/img/${product2.image}`).default}
                  alt={product2.title}
                />
              </div>
            </td>
            <td>{product2.title}</td>
            <td>使用量 / 全頭</td>
            <td>
              <ul>
                <li>ショート</li>
                <li>10 〜 20プッシュ</li>
              </ul>
            </td>
            <td>
              <ul>
                <li>ミディアム</li>
                <li>20 〜 40プッシュ</li>
              </ul>
            </td>
            <td>
              <ul>
                <li>ロング</li>
                <li>40 〜 60プッシュ</li>
              </ul>
            </td>
          </tr>
          <tr>
            <th>ST3</th>
            <td>
              <div>
                <img
                  src={require(`../dist/img/${product3.image}`).default}
                  alt={product3.title}
                />
              </div>
            </td>
            <td>{product3.title}</td>
            <td>使用量 / 全頭</td>
            <td>
              <ul>
                <li>ショート</li>
                {product3.id === "I" ? (
                  <li>20 〜 40g</li>
                ) : (
                  <li>
                    6 〜 9g
                    <br />2 〜 3プッシュ
                  </li>
                )}
              </ul>
            </td>
            <td>
              <ul>
                <li>ミディアム</li>
                {product3.id === "I" ? (
                  <li>40 〜 60g</li>
                ) : (
                  <li>
                    12 〜 15g
                    <br />4 〜 5プッシュ
                  </li>
                )}
              </ul>
            </td>
            <td>
              <ul>
                <li>ロング</li>
                {product3.id === "I" ? (
                  <li>60 〜 80g</li>
                ) : (
                  <li>
                    18 〜 21g
                    <br />6 〜 7プッシュ
                  </li>
                )}
              </ul>
            </td>
          </tr>
          <tr>
            <th>ST4</th>
            <td>
              <div>
                <img
                  src={require(`../dist/img/${product4_output.image}`).default}
                  alt={product4_output.title}
                />
              </div>
            </td>
            <td>ST{product4_output.title}4</td>
            <td>使用量 / 全頭</td>
            <td>
              <ul>
                <li>ショート</li>
                <li>
                  3 〜 6g
                  <br />1 〜 2プッシュ
                </li>
              </ul>
            </td>
            <td>
              <ul>
                <li>ミディアム</li>
                <li>
                  6 〜 9g
                  <br />2 〜 3プッシュ
                </li>
              </ul>
            </td>
            <td>
              <ul>
                <li>ロング</li>
                <li>
                  9 〜 12g
                  <br />3 〜 4プッシュ
                </li>
              </ul>
            </td>
          </tr>
        </table>

        <div style={{display:"grid"  , gridColumnGap:"5px", gridTemplateColumns:"1fr 2fr" }}>  
        <Link  onClick={() => deleteStep()}  className="c-question__btn2 p-output__btn--v2">
          BACK
        </Link>

        <Link
          to={{
            pathname: "/home-care",
            state: {
              answer1_5,
              product1,
              product1_old,
              product2,
              product3,
              product4,
              product4_old,
              product1_2Visible,
            },
          }}
          className="c-question__btn"
        >
       おすすめホームケアアイテム
        </Link>

        </div>
      </section>
    </section>
  );
};

export default Output;
